import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  selectAlbum: `${NAMESPACE}_SELECT_ALBUM`,
  addAllPhotosToAlbum: `${NAMESPACE}_ADD_ALL_PHOTO_ALBUM`,
  addAllPhotosAlbums: `${NAMESPACE}_ADD_ALL_PHOTO_ALBUMS`,
  selectMultipleAlbums: `${NAMESPACE}_SELECT_MULTIPLE_ALBUMS`,
  deselectAlbum: `${NAMESPACE}_DESELECT_ALBUM`,
  deselectAlbums: `${NAMESPACE}_DESELECT_ALBUMS`,
  selectPhoto: `${NAMESPACE}_SELECT_PHOTO`,
  deselectPhoto: `${NAMESPACE}_DESELECT_PHOTO`,
  setLoading: `${NAMESPACE}_SET_LOADING`,
  clear: `${NAMESPACE}_CLEAR`
};

export const actionCreators = {
  selectAlbum: (albumId) => ({
    type: actions.selectAlbum,
    payload: { albumId }
  }),
  addAllPhotosToAlbum: (photos, albumId) => ({
    type: actions.addAllPhotosToAlbum,
    payload: { photos, albumId }
  }),
  addAllPhotosAlbums: (allPhotoAlbums) => ({
    type: actions.addAllPhotosAlbums,
    payload: allPhotoAlbums
  }),
  selectMultipleAlbums: (albumsId) => ({
    type: actions.selectMultipleAlbums,
    payload: albumsId
  }),
  deselectAlbum: (albumId) => ({
    type: actions.deselectAlbum,
    payload: { albumId }
  }),
  deselectAlbums: (albumIds) => ({
    type: actions.deselectAlbums,
    payload: { albumIds }
  }),
  selectPhoto: (albumId, photo) => ({
    type: actions.selectPhoto,
    payload: { albumId, photo }
  }),
  deselectPhoto: (albumId, photoId) => ({
    type: actions.deselectPhoto,
    payload: { albumId, photoId }
  }),
  setLoading: (isLoading) => ({
    type: actions.setLoading,
    payload: { isLoading }
  }),
  clear: () => ({ type: actions.clear })
};

export default {
  actions,
  actionCreators
};
